import { branch, renderNothing } from 'recompose'

import { fetchPosts, queryPosts } from 'wordpress/actions'
import { Image } from 'wordpress/components'
import { withWordpressLanguage } from 'wordpress/utils'
import Meta from 'shared/components/Meta'
import { loadOnMount } from 'shared/hoc'

import { postSelector } from '../selectors'
import contentToComponents from '../helpers'

import '../styles/content.scss'

const ContentPage = ({ post }) => (
    <div id="content" className="content">
        <Meta {...post} />

        <Image className="background" image={post.background} background />
        <div className="container">
            {post.content.map((c, i) => contentToComponents({ ...c, key: i, id: post.id }))}
        </div>
    </div>
)

export default compose(
    withWordpressLanguage,
    connect(
        createStructuredSelector({
            post: postSelector,
        }),
        { fetchPosts, queryPosts }
    ),
    branch(
        props => props.slug,
        loadOnMount('queryPosts', ({ slug }) => ['content', { slug }]),
        loadOnMount('fetchPosts', props => ['content', [props.id]])
    ),
    branch(props => !props.post, renderNothing)
)(ContentPage)
